import axios from "axios";
import { useEffect, useState } from "react";
import { E_immatriculation } from "../../../../constants/constant";
import Label from "../../../../components/title/label";
import Checkbox from "../../../../components/button/Checkbox";
import Input from "../../../../components/input/Input";
import { Link } from "react-router-dom";
import { RiArrowGoBackFill } from "react-icons/ri";

import { MdOpenInNew } from "react-icons/md";
import Table from "../../../../components/table/Table";
import { Navbar } from "../../../../components/navbar/Navbar";
import BackButton from "../../../../components/button/BackButton";

function AssocieContribuable() {



    const [add , setAdd] = useState(false);
    const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
   
    const [ContribuableData] = useState(
    JSON.parse(selectedData )
  );
  
  // data selected associe table 
  const [selectedRowIndexAssocie, setSelectedRowIndexAssocie] = useState(null);
  const [DataSelectedAssocie , setDataSelectedAssocie] = useState([]);
  const [Actionnaire , setActionnaire] = useState([]);
              
  const [TableActionnaire , setTableActionniare] = useState([]);
  
  
  const filterId = ContribuableData.id
  
  
  
      
   
      
      useEffect(() => {
        // Récupérer les données depuis le backend
        axios.get(`${E_immatriculation}/actionnaire`)
          .then((response) => setTableActionniare(response.data))
          .catch((error) => {console.error(error)});
      }, []);
      
      useEffect(() => {
        const filteredData = TableActionnaire.filter((item) =>
          item.id_contribuable?.toString().includes(filterId)
        );
        setActionnaire(filteredData);
      }, [TableActionnaire , filterId]);
  
      console.log("Actionnaire get :" , TableActionnaire)
      console.log("Données filtrées :", Actionnaire);
  
  
    
  
  
  
    // associe Table 
    const HeadersAssocie = ["Type association" , "Nom actionnaire" , "Fonction" , " Résident" , "N° CIN ou Passport" , " Adresse Actionnaire" , "Autre activité " , " Référence contribuable " , "Référence fiscal actionnaire" , "Action ou actionnaire" , "associe unique" , "Email actionnaire" , "numéro actionnaire" , "Gérant" , "CIN / Passport Gérant" , "Siege"]
  // Préparation des données pour le tableau
  const dataAssocie = Array.isArray(Actionnaire) ? Actionnaire.map((item) => [
    item.type,
    item.nom_actionnaire,
    item.fonction_actionnaire,
    item.resident_actionnaire ? "Oui" : "Non",
    item.cin_passport_actionnaire,
    item.adresse_actionnaire,
    item.autre_activite_actionnaire,
    item.id_contribuable,
    item.nif_actionnaire,
    item.action_ou_actionnaire,
    item.associe_unique_actionnaire ? "Oui" : "Non",
    item.email_actionnaire,
    item.numero_actionnaire,
    item.gerant,
    item.cin_passport_gerant,
    item.siege
  ]) : [["Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun " , " Aucun " , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun" , "Aucun"]];
   
  
  const [isStorageUpdatedAssocie, setIsStorageUpdatedAssocie] = useState(false);
  
    useEffect(() => {
       console.log(DataSelectedAssocie)
       setIsStorageUpdatedAssocie(false);
    }, [DataSelectedAssocie, isStorageUpdatedAssocie]);
    
    const handleSelectedDataTableAssocie = (rowIndex) => {
      // Check if the clicked row is already selected
      if (rowIndex === selectedRowIndexAssocie) {
        // If selected, unselect it
        setSelectedRowIndexAssocie(null);
        setDataSelectedAssocie([]);
      } else {
        // If not selected, select it
        setSelectedRowIndexAssocie(rowIndex);
        const selectedRowDataAssocie = TableActionnaire[rowIndex];
        setDataSelectedAssocie(selectedRowDataAssocie);
        console.log("selected:", DataSelectedAssocie);
      }
    };
    
  
  
  
  
  
  
  console.log("Data selected" , DataSelectedAssocie.id)
  
  
  
  
  
  
  
  // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
        Associés
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    
     
    return (
         <div className="w-full bg-[#212122] h-screen">
           <Navbar content={contentNavbar} />
           <main className="">  <div >
 
 
     <div className="flex justify-center   p-4">
       <div className="flex flex-col " >
       { add === true && ( 
             <div className=" flex justify-center">
  <div className="flex flex-col">
  <div className='flex justify-between mt-6 '>
     <Label text="Type d'associés / Actionnaires"></Label>
     <div className="flex justify-between ">
     <Checkbox label="Personne physique" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , type : "Personne physique"})} checked={DataSelectedAssocie.type === "Personne physique"}></Checkbox>
     <Checkbox label="Personne morale" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , type : "Personne morale"})} checked={DataSelectedAssocie.type ==="Personne morale"}></Checkbox>
     <Checkbox label="Personne morale etrangère/Etat" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , type : "Personne morale etrangère/Etat"})} checked={DataSelectedAssocie.type === "Personne morale etrangère/Etat"}></Checkbox>
     </div>
   </div>
   {DataSelectedAssocie.type === "Personne physique" && (
     <>
     <div className="flex justify-between mt-6">
       <Label text="Nom"></Label>
       <Input type="text" value={DataSelectedAssocie?DataSelectedAssocie.nom_actionnaire : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , nom_actionnaire : e.target.value})}
       ></Input>
 
     </div>
     <div className="flex justify-between mt-6">
       <Label text="Fonction"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.fonction_actionnaire : ""}
       onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , fonction_actionnaire : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
             <Label text="Resident  " />
       <div className="flex justify-between w-[200px]">
     <Checkbox label="Oui" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , resident_actionnaire : true})} checked={DataSelectedAssocie.resident_actionnaire === true}></Checkbox>
     <Checkbox label="Non" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , resident_actionnaire : false})} checked={DataSelectedAssocie.resident_actionnaire === false }></Checkbox>
     </div>
     </div>
     { DataSelectedAssocie.resident_actionnaire === true && (
       <>
       <div className="flex justify-between mt-6">
 <Label text="Numero CIN"></Label>
 <Input type="text"
 value={DataSelectedAssocie? DataSelectedAssocie.cin_passeport_actionnaire : ""}
 onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , cin_passeport_actionnaire : e.target.value})}
 ></Input>
       </div>
       </>
     )
 
     }
     { DataSelectedAssocie.resident_actionnaire ===  false && (
       <>
       <div className="flex justify-between mt-6">
 <Label text="Numéro Passeport ou Carte Résident"></Label>
 <Input type="text"
 
 value={DataSelectedAssocie? DataSelectedAssocie.cin_passeport_actionnaire : ""}
 onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , cin_passeport_actionnaire : e.target.value})}
 ></Input>
       </div>
       </>
     )
 
     }
     <div className="flex justify-between mt-6">
       <Label text="Adresse"></Label>
       <Input type="text"
       value={DataSelectedAssocie? DataSelectedAssocie.adresse_actionnaire : ""}
       onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , adresse_actionnaire : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
             <Label text="Autre activité " />
       <div className="flex justify-between w-[300px]">
     <Checkbox label="Avec RF" onChange={()=> setDataSelectedAssocie({...DataSelectedAssocie , autre_activite_actionnaire : "Avec RF" })} checked={ DataSelectedAssocie.autre_activite_actionnaire ==="Avec RF"}></Checkbox>
     <Checkbox label="Salarié" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , autre_activite_actionnaire : "Salarié"})} checked={ DataSelectedAssocie.autre_activite_actionnaire ==="Salarié"}></Checkbox>
     <Checkbox label="Aucune" onChange={()=>setDataSelectedAssocie({...DataSelectedAssocie , autre_activite_actionnaire : "Aucune"})} checked={DataSelectedAssocie.autre_activite_actionnaire === "Aucune"}></Checkbox>
     </div>
     </div>
     { DataSelectedAssocie.autre_activite_actionnaire ==="Avec RF" && (
       <> 
     <div className="flex justify-between mt-6">
       <Label text="RF"></Label>
       <Input type="text"
       value={DataSelectedAssocie ? DataSelectedAssocie.nif_actionnaire : ""}
       onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , nif_actionnaire : e.target.value })}
       ></Input>
     </div>  
       </>
     )
 
     }
     <div className="flex justify-between mt-6">
       <Label text="E-mail"></Label>
       <Input type="email"
       value={DataSelectedAssocie? DataSelectedAssocie.email_actionnaire : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , email_actionnaire : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
       <Label text="Telephone"></Label>
       <Input type="number"
       value={DataSelectedAssocie? DataSelectedAssocie.numero_actionnaire: ""}
       onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , numero_actionnaire : e.target.value})}
       ></Input>
     </div>
     </>
   )}
   { DataSelectedAssocie.type === "Personne morale etrangère/Etat" && (
     <>
     <div className="flex justify-between mt-6">
       <Label text="Nom"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.nom_actionnaire :""}
       onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , nom_actionnaire : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
       <Label text="Adresse"></Label>
       <Input type="text"
       value={DataSelectedAssocie? DataSelectedAssocie.adresse_actionnaire : ""}
       onChange={(e )=> setDataSelectedAssocie({...DataSelectedAssocie , adresse_actionnaire : e.targt.value})}
       ></Input>
     </div>
     </>
   )
 
   }
    { DataSelectedAssocie.type === "Personne morale" && (
     <>
     <div className="flex justify-between mt-6">
       <Label text="RF"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.nif_actionnaire : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , nif_actionnaire : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
       <Label text="Gérant"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.gerant : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , gerant: e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
       <Label text="CIN /Passport"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.cin_passport_gerant : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , cin_passport_gerant : e.target.value})}
       ></Input>
     </div>
     <div className="flex justify-between mt-6">
       <Label text="Siege"></Label>
       <Input type="text"
       value={DataSelectedAssocie?DataSelectedAssocie.siege : ""}
       onChange={(e)=> setDataSelectedAssocie({...DataSelectedAssocie , siege : e.target.value})}
       ></Input>
     </div>
     </>
   )
 
   }
               <div className="flex justify-between mt-6">
             <Label text="Associé unique" />
       <div className="flex justify-between w-[200px]">
     <Checkbox label="Oui" onChange={()=>{setDataSelectedAssocie({...DataSelectedAssocie, associe_unique_actionnaire : true })}} checked={DataSelectedAssocie.associe_unique_actionnaire === true}></Checkbox>
     <Checkbox label="Non" onChange={()=>{setDataSelectedAssocie({...DataSelectedAssocie , associe_unique_actionnaire : false })}} checked={DataSelectedAssocie.associe_unique_actionnaire === false}></Checkbox>
     </div>
           </div>
           { DataSelectedAssocie.associe_unique_actionnaire === true && (
             <>
             <div className="flex justify-between mt-6">
             <Label text="% Action ou" />
               <Input type="text"
               value={DataSelectedAssocie? DataSelectedAssocie.action_ou_actionnaire : ""}
               onChange={(e)=>setDataSelectedAssocie({...DataSelectedAssocie , action_ou_actionnaire : e.target.value})}
               ></Input>
             </div>
             </>
           )
 
           }
           <div className="flex justify-center mt-6"> 
           <button onClick={()=> setAdd(false)}  className="border-[2px] ml-4 p-2 border-white rounded hover:bg-black/70 text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl mr-2"/> Annuler</button>
           </div>
  </div>
             </div>
            )}
           
 { add === false  && (
   
   <div className="flex justify-center " >
    <div className="flex flex-col">
    
     <div className=" w-[1300px] mt-6 ">
   <Table
 
 headers={HeadersAssocie}
 data={dataAssocie}
 onClick={handleSelectedDataTableAssocie}
 selectedRowIndex={selectedRowIndexAssocie }
 
 ></Table>
 </div>
 <div className="flex justify-center mt-6 mb-6">
 <div >
             <button  onClick={()=> setAdd(true)}  className="border-[2px] p-2 border-white rounded hover:bg-black/70 hover:text-white "><MdOpenInNew className="text-white"></MdOpenInNew></button>
 </div> 
 
 </div>
 <div className="flex justify-between">
   
 <Link to={`/SituationGeographiqueIm`}  className="border-[2px] mt-6 mb-6 w-40 p-2 border-white text-white rounded hover:bg-black/70 hover:text-white flex flex-row"><RiArrowGoBackFill  className="text-2xl mr-2"/> Fermer</Link>
 </div>
    </div>
 
 </div>
 
 
 )}
 </div>
 </div>
  
 
   </div>
</main>
         </div>
         )
  }

export default AssocieContribuable